import * as requestFromServer from "./Crud";
import { tournamentsSlice, callTypes } from "./Slice";
import { NotificationManager } from "react-notifications";

const { actions } = tournamentsSlice;

export const fetchTournamentsListList = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  // console.log('queryParams: ', queryParams)
  return requestFromServer
    .getList(queryParams)
    .then((response) => {
      console.log("response.data", response);
      if (response.success) {
        const tournamentslistlist = response;
        dispatch(actions.tournamentslist({ tournamentslistlist }));
        return tournamentslistlist;
      }
    })
    .catch((error) => {
      console.log("error", error);
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};


export const updateMinimumSlot = queryParams => dispatch => {
  console.log('queryParams', queryParams)
  // dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .updateMinimumSlot(queryParams)
    .then(response => {
      return response
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      // dispatch(actions.catchError({ error, callType: callTypes.list }));
      return false
    });
};
export const fetchTournamentsListListopen = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  // console.log('queryParams: ', queryParams)
  return requestFromServer
    .getListopen(queryParams)
    .then((response) => {
      console.log("response.data", response);
      if (response.success) {
        const tournamentslistlist = response;
        dispatch(actions.tournamentslist({ tournamentslistlist }));
        return tournamentslistlist;
      }
    })
    .catch((error) => {
      console.log("error", error);
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchGameList = (queryParams) => (dispatch) => {
  // console.log('queryParams MOHIT:', queryParams)
  // dispatch(actions.emptyList());
  // console.log('queryParams MOHIT  ee: ', queryParams)
  return requestFromServer
    .getAllGamesList(queryParams)
    .then((response) => {
      // console.log("response::getGameList ", response);
      // const { totalCount, entities } = response.data;
      const totalCount = response.totalRecord;
      const entities = response.list;
      dispatch(actions.gameList({ totalCount, entities }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      //  NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchTournamentList = (queryParams) => (dispatch) => {
  // console.log('queryParams MOHIT:', queryParams)
  // dispatch(actions.emptyList());
  // console.log('queryParams MOHIT  ee: ', queryParams)
  return requestFromServer
    .getAllTournamentList(queryParams)
    .then((response) => {
      // const { totalCount, entities } = response.data;
      const entities = response.tournaments;
      dispatch(actions.tournamentIdList({ entities }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchContestUsersList = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  // console.log('queryParams: ', queryParams)
  return requestFromServer
    .getContestUsersList(queryParams)
    .then((response) => {
      const contestUsers = response;
      dispatch(actions.contestUsersList({ contestUsers }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchAcceptedUsersList = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  // console.log('queryParams: ', queryParams)
  return requestFromServer
    .acceptedTournamentUserList(queryParams)
    .then((response) => {
      // console.log("response::fetchContestUsersList ", response);
      const acceptedUserList = response;
      dispatch(actions.acceptedUserList({ acceptedUserList }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchAllocatedUsersList = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  // console.log('queryParams: ', queryParams)
  return requestFromServer
    .contestAllocatedUserList(queryParams)
    .then((response) => {
      // console.log("response::fetchContestUsersList ", response);
      const allocatedUserList = response;
      dispatch(actions.allocatedUserList({ allocatedUserList }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchContestViewDetails = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  // console.log('queryParams: ', queryParams)
  return requestFromServer
    .contestViewbyId(queryParams)
    .then((response) => {
      const contestData = response;
      dispatch(actions.contestData({ contestData }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const acceptTournamentUsersList = (queryParams) => (dispatch) => {
  return requestFromServer
    .acceptTournamentUser(queryParams)
    .then((response) => {
      console.log("response::fetchContestUsersList ", response);
      return true;
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const allocateUserToContest = (queryParams) => (dispatch) => {
  return requestFromServer
    .acceptUserForContest(queryParams)
    .then((response) => {
      console.log("response::fetchContestUsersList ", response);
      return true;
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const rejectTournamentUsersList = (queryParams) => (dispatch) => {
  return requestFromServer
    .rejectTournamentUser(queryParams)
    .then((response) => {
      return true;
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const deleteStatusTournamentUsersList = (queryParams) => (dispatch) => {
  return requestFromServer
    .deleteStatusTournamentUser(queryParams)
    .then((response) => {
      return true;
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchCountriesListAction = (queryParams) => (dispatch) => {
  console.log("queryParams -> user -> com:", queryParams);
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .fetchCountriesList(queryParams)
    .then((response) => {
      console.log("response::All Country List", response);
      // const { totalCount, entities } = response.data;
      const countryList = response;
      console.log("countryList", countryList);
      dispatch(actions.CountryList({ countryList }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchCurrencyListAction = (queryParams) => (dispatch) => {
  console.log("queryParams -> user -> com:", queryParams);
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .fetchCurrencyList(queryParams)
    .then((response) => {
      console.log("response::All Currency List", response);
      // const { totalCount, entities } = response.data;
      const currencyList = response;
      console.log("countryList", currencyList);
      dispatch(actions.CurrencyList({ currencyList }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchCountriesDropdownListAction = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .fetchCountriesDropdownList(queryParams)
    .then((response) => {
      console.log("response::All Country List", response);
      // const { totalCount, entities } = response.data;
      const countryDropdownList = response;
      console.log("countryDropdownList", countryDropdownList);
      dispatch(actions.CountryDropdownList({ countryDropdownList }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchGameListTournaments = (queryParams) => (dispatch) => {
  // queryParams.fromDate = queryParams?.dateRange?.from;
  // queryParams.toDate = queryParams.dateRange?.to;
  // delete queryParams.dateRange;
  const body = {}; // console.log("queryParams",queryParams)
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  // console.log('queryParams: ', queryParams)
  return requestFromServer
    .getGameList(body)
    .then((response) => {
      console.log("response::getGameList ", response);
      // // const { totalCount, entities } = response.data;
      // const totalCount = response.totalRecord;
      // const entities = response.data;
      // dispatch(actions.gameList({ totalCount, entities }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const fetchGameTypeTournaments = (queryParams) => (dispatch) => {
  // queryParams.fromDate = queryParams?.dateRange?.from;
  // queryParams.toDate = queryParams.dateRange?.to;
  // delete queryParams.dateRange;
  const body = {}; // console.log("queryParams",queryParams)
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  // console.log('queryParams: ', queryParams)
  return requestFromServer
    .gameTypeList(body)
    .then((response) => {
      console.log("response::gameTypeList ", response.data);
      // // const { totalCount, entities } = response.data;
      // const totalCount = response.totalRecord;
      const gameTypeData = response.data;
      dispatch(actions.gameTypeList({ gameTypeData }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchCurrencyDropdownListAction = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .fetchCurrencyDropdownList(queryParams)
    .then((response) => {
      console.log("response::All Country List", response);
      // const { totalCount, entities } = response.data;
      const currencyDropdownList = response;
      console.log("countryDropdownList", currencyDropdownList);
      dispatch(actions.CurrencyDropdownList({ currencyDropdownList }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchSingleCompany = (queryParams) => (dispatch) => {
  if (queryParams != undefined) {
    dispatch(actions.emptyList());
    dispatch(actions.startCall({ callType: callTypes.list }));
    return requestFromServer
      .getCompanyById(queryParams)
      .then((response) => {
        // console.log("response::fetchSingle", response);
        // const { totalCount, entities } = response.data;
        const singleCompanyFetched = response.data;
        // console.log("singleCompanyFetched", singleCompanyFetched)
        dispatch(actions.singleCompanyFetched({ singleCompanyFetched, singleCompanyId: queryParams }));
      })
      .catch((error) => {
        const errMsg =
          error.response && error.response.data && error.response.data.errors
            ? error.response.data.errors[0].msg
            : error.message;
        NotificationManager.error(errMsg, "Error");
        dispatch(actions.catchError({ error, callType: callTypes.list }));
      });
  }
};

export const uploadImage = (queryParams) => (dispatch) => {
  return requestFromServer
    .uploadImage(queryParams.img)
    .then((response) => {
      console.log("responseuploadImage", response);
      // console.log(response)

      const entities = response.data.image;
      const imageField = queryParams.name;

      return { entities, imageField };
    })
    .catch((error) => {
      console.log("error", error);
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchSingle = (id) => (dispatch) => {
  if (!id) {
    return dispatch(
      actions.singleItemFetched({ tournamentForEdit: undefined })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getItemById(id)
    .then((response) => {
      const item = response.data;
      dispatch(actions.singleItemFetched({ tournamentForEdit: item }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const fetchSingleTournament = (id, isExtra) => (dispatch) => {
  if (!id) {
    return dispatch(
      actions.singleItemFetched({ tournamentForEdit: undefined })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getTournamentById(id, isExtra)
    .then((response) => {
      const item = response.data;
      console.log("tournamentId", response?.data?._id);

      localStorage.setItem("tournamentId", response?.data?._id); // Store id in localStorage
      dispatch(actions.singleItemFetched({ tournamentForEdit: item }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
////////////////Optimisation APIS/////////////////////
export const fetchTournamentRounds = (id) => (dispatch) => {
  if (!id) {
    return dispatch(
      actions.roundsItemFetched({ tournamentRounds: undefined })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getTournamentRoundsById(id)
    .then((response) => {
      const item = response.data;
      dispatch(actions.roundsItemFetched({ tournamentRounds: item }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const fetchTournamentRoundMatches = (id, data) => (dispatch) => {
  return requestFromServer
    .getTournamentMatchesByRounds(id, data)
    .then((response) => {
      console.log("getTournamentRoundsById", response)
      return response
    })
    .catch((error) => {
      console.log("error.response")
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
      throw error
    });
};
export const exportJoinedUserByContestId = id => dispatch => {
  // dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .exportJoinedUserByContestIdApi(id)
    .then((response) => {
      console.log(response)
      if(response?.data?.link){
        NotificationManager.success('success', "File Download Success");
        window.open(response?.data?.link, "_blank");          
      } 
      return true;
    })
    .catch(error => {
      // error.clientMessage = "Can't update item";
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      console.log("errMsg", errMsg);
      NotificationManager.error(errMsg, 'Error');
      // dispatch(actions.catchError({ errMsg, callType: callTypes.action }));
      return false;
    });
};
export const fetchTournamentRules = (id) => (dispatch) => {
  if (!id) {
    return dispatch(actions.rulesFetched({ tournamentRules: undefined }));
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getTournamentRulesById(id)
    .then((response) => {
      const item = response?.data;
      console.log("rulesssss", response?.data)
      dispatch(actions.rulesFetched({ tournamentRules: item }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const fetchTournamentPointPool = (id) => (dispatch) => {
  if (!id) {
    return dispatch(
      actions.pointPoolFetched({ tournamentPointPool: undefined })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getTournamentPointPoolById(id)
    .then((response) => {
      const item = response.data;
      dispatch(actions.pointPoolFetched({ tournamentPointPool: item }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const fetchTournamentPrizePool = (id) => (dispatch) => {
  if (!id) {
    return dispatch(
      actions.prizePoolFetched({ tournamentPrizePool: undefined })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getTournamentPrizePoolById(id)
    .then((response) => {
      const item = response.data;
      dispatch(actions.prizePoolFetched({ tournamentPrizePool: item }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const fetchGamerjiPointSummaryexport = (queryParams) => (dispatch) => {
  console.log("calling getCrmCSV");

  dispatch(actions.startPointSummaryCall({ callType: callTypes.action }));
  // dispatch(actions.emptyList());
  // dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getItemGamerjiPointSummaryByIdexport(queryParams)
    .then((response) => {
      console.log("calliddddng getGstExport", response?.data?.link);
      if (response?.data?.link) {
        NotificationManager.success("success", "File Download Success");
        window.open(response?.data?.link, "_blank");
        return true
      }
      dispatch(actions.endPointSummaryCall({ callType: callTypes.action }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      console.log("**********************", error.response.data);
      NotificationManager.error(error?.response?.data.msg || "Error", "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchGamerjiRankSummaryexport = (queryParams) => (dispatch) => {
  console.log("calling getCrmCSV");

  // dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getGamerjiRankSummaryByIdexport(queryParams)
    .then((response) => {
      console.log("calliddddng getGstExport", response?.data?.link);
      if (response?.data?.link) {
        setTimeout(() => {
          NotificationManager.success(
            "success",
            "File downloaded succesfully!!"
          );
        }, 1000);
        window.open(response?.data?.link, "_blank");
        dispatch(actions.catchError({ callType: callTypes.action }));
      }
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      console.log("**********************", error.response.data);
      NotificationManager.error(error?.response?.data.msg || "Error", "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const fetchGamerjiPointSummary = (id) => (dispatch) => {
  if (!id) {
    return dispatch(
      actions.fetchPointSummaryFetched({ tournamentForEdit: undefined })
    );
  }
  dispatch(actions.startPointSummaryCall({ callType: callTypes.action }));
  return requestFromServer
    .getItemGamerjiPointSummaryById(id)
    .then((response) => {
      const item = response;
      const tounamentUsers = response.tounamentUsers;
      dispatch(
        actions.fetchPointSummaryFetched({
          pointSummary: item,
          tounamentUsers: tounamentUsers,
        })
      );
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const fetchGamerjiRankSummary = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getGamerjiRankSummary(id)
    .then((response) => {
      console.log("getRankSummary", response);
      const pointSummary = response;
      const tounamentUsers = response.tounamentUsers;
      const tounamentUsers1 = response.tounamentUsersData1;
      dispatch(
        actions.fetchRankSummaryFetched({
          pointSummary: pointSummary,
          tounamentUsers: tounamentUsers,
          tounamentUsers1: tounamentUsers1,
        })
      );
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchPointSummary = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getItemPointSummaryById(id)
    .then((response) => {
      console.log(response);
      dispatch(actions.pointSummaryData(response));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
//CURD
export const deleteItem = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteItem(id)
    .then((response) => {
      dispatch(actions.itemDeleted({ id }));
      NotificationManager.success("success", "Data deleted successfully!");
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createSkyItem = (item) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createSkyItem(item)
    .then((response) => {
      console.log("create", response);
      const { addTournaments } = response;
      NotificationManager.success("success", "Data saved successfully!");
      dispatch(actions.itemCreated({ addTournaments }));
      return true;
    })
    .catch((error) => {
      console.log(error);
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateSkyItem = (item) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateSkyItem(item)
    .then(() => {
      NotificationManager.success("success", "Data saved successfully!");
      dispatch(actions.itemUpdated({ item }));
      return true;
    })
    .catch((error) => {
      // error.clientMessage = "Can't update item";
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ errMsg, callType: callTypes.action }));
      return false;
    });
};

export const createItem = (item) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createItem(item)
    .then((response) => {
      console.log("create", response);
      const { addTournaments } = response;
      NotificationManager.success("success", "Data saved successfully!");
      dispatch(actions.itemCreated({ addTournaments }));
      return true;
    })
    .catch((error) => {
      console.log(error);
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateItem = (item) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateItem(item)
    .then(() => {
      NotificationManager.success("success", "Data saved successfully!", 400);
      dispatch(actions.itemUpdated({ item }));
      return true;
    })
    .catch((error) => {
      // error.clientMessage = "Can't update item";
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ errMsg, callType: callTypes.action }));
      return false;
    });
};
export const updateEventWinnings = (item, id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateEventWinnings(item, id)
    .then(() => {
      NotificationManager.success("success", "Data saved successfully!");
      dispatch(actions.itemUpdated({ item }));
      return true;
    })
    .catch((error) => {
      // error.clientMessage = "Can't update item";
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ errMsg, callType: callTypes.action }));
      return false;
    });
};

export const updateGamerjiEventWinningsreward = (item, id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateGamerjiEventWinningsreward(item, id)
    .then(() => {
      NotificationManager.success("success", "Data saved successfully!");
      dispatch(actions.itemUpdated({ item }));
      return true;
    })
    .catch((error) => {
      // error.clientMessage = "Can't update item";
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ errMsg, callType: callTypes.action }));
      return false;
    });
};
export const updateGamerjiEventWinnings = (item, id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateGamerjiEventWinnings(item, id)
    .then(() => {
      NotificationManager.success("success", "Data saved successfully!");
      dispatch(actions.itemUpdated({ item }));
      return true;
    })
    .catch((error) => {
      // error.clientMessage = "Can't update item";
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ errMsg, callType: callTypes.action }));
      return false;
    });
};

export const updateItemsStatus = (ids, status) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateItemsStatus(ids, status)
    .then(() => {
      dispatch(actions.itemStatusUpdated({ ids, status }));
    })
    .catch((error) => {
      // error.clientMessage = "Can't update items status";
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteItems = (ids) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteItems(ids)
    .then(() => {
      dispatch(actions.itemsDeleted({ ids }));
    })
    .catch((error) => {
      // error.clientMessage = "Can't delete items";
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createTournamentsRound = (params) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createTournamentsRound(params)
    .then((response) => {
      console.log("create", response);
      // const { addTournaments } = response;
      // NotificationManager.success('success', 'Round has been created successfully!');
      // dispatch(actions.itemCreated({ addTournaments }));
      return true;
    })
    .catch((error) => {
      // error.clientMessage = "Can't delete items";
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const setContestIdPassword = (item) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .setContestIdPassword(item)
    .then(() => {
      NotificationManager.success("success", "Data saved successfully!");
      //dispatch(actions.itemUpdated({ item }));
      return true;
    })
    .catch((error) => {
      // error.clientMessage = "Can't update item";
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ errMsg, callType: callTypes.action }));
      return false;
    });
};

export const resetRoomIdPassword = (item) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .resetRoomIdPassword(item)
    .then(() => {
      NotificationManager.success("success", "Data saved successfully!");
      //dispatch(actions.itemUpdated({ item }));
      return true;
    })
    .catch((error) => {
      // error.clientMessage = "Can't update item";
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ errMsg, callType: callTypes.action }));
      return false;
    });
};

export const rescheduleContest = (item) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .rescheduleContest(item)
    .then(() => {
      NotificationManager.success("success", "Data saved successfully!");
      //dispatch(actions.itemUpdated({ item }));
      return true;
    })
    .catch((error) => {
      // error.clientMessage = "Can't update item";
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ errMsg, callType: callTypes.action }));
      return false;
    });
};

export const saveScreenShotImages = (queryParams) => (dispatch) => {
  return requestFromServer
    .saveScreenShotImage(queryParams)
    .then((response) => {
      console.log(response);
      // const entities = response.data.item;
      // const imageField = queryParams.name;
      NotificationManager.success("success", "Data saved successfully!");
      //dispatch(actions.saveScreenShot(queryParams.screenshotImages));
      return true;
    })
    .catch((error) => {
      console.log("error", error);
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const resetScreenShotImage = (item) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .resetScreenshotImage(item)
    .then(() => {
      NotificationManager.success("success", "Data saved successfully!");
      //dispatch(actions.itemUpdated({ item }));
      return true;
    })
    .catch((error) => {
      // error.clientMessage = "Can't update item";
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ errMsg, callType: callTypes.action }));
      return false;
    });
};

export const cancelContest = (item) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .contestCancel(item)
    .then(() => {
      NotificationManager.success("success", "Data saved successfully!");
      dispatch(actions.itemUpdated({ item }));
      return true;
    })
    .catch((error) => {
      // error.clientMessage = "Can't update item";
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ errMsg, callType: callTypes.action }));
      return false;
    });
};

export const saveTotalJoinedPlayers = (queryParams) => (dispatch) => {
  return requestFromServer
    .updateTotalJoinedPlayers(queryParams)
    .then((response) => {
      console.log("response", response);
      // const entities = response.data.item;
      // const imageField = queryParams.name;
      NotificationManager.success("success", "Data saved successfully!");
      //dispatch(actions.saveTotalJoinedPlayers(queryParams.totalJoinedPlayers));
      return true;
    })
    .catch((error) => {
      console.log("error", error);
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const uploadBracketsImage = (queryParams) => (dispatch) => {
  return requestFromServer
    .uploadBracketsImage(queryParams.img)
    .then((response) => {
      console.log("response::createUploadImage ", response);

      // const uploadimage = response;
      // const imageField = queryParams.name;
      dispatch(actions.uploadBracketsImage(response.data.image));
      return true;
    })
    .catch((error) => {
      console.log("error::createUploadImage ", error);
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const saveBracketsImage = (body) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveBracketsImage(body)
    .then(() => {
      NotificationManager.success(
        "success",
        "Brackets Image uploaded successfully!!"
      );
      return true;
    })
    .catch((error) => {
      // error.clientMessage = "Can't delete items";
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const deleteMatchRound = (roundId) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteMatchRound(roundId)
    .then((msg) => {
      console.log("msg", msg);
      NotificationManager.success(
        "success",
        "Round has been deleted successfully!!"
      );
      return true;
    })
    .catch((error) => {
      // error.clientMessage = "Can't delete items";

      const errMsg =
        error.response && error.response.data.data && error.response.data.data
          ? error.response.data.data[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const saveContestResult = (body) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveContestResult(body)
    .then(() => {
      NotificationManager.success(
        "success",
        "Contest result has been saved successfully!!"
      );
      return true;
    })
    .catch((error) => {
      // error.clientMessage = "Can't delete items";
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const getRankSummary = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getRankSummary(id)
    .then((response) => {
      console.log("getRankSummary", response);
      // const { totalCount, entities } = response.data;
      // const currencyList = response;
      // console.log("countryList", currencyList)
      dispatch(actions.rankSummaryData(response));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const updateWinning = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .updateWinning(payload)
    .then((response) => {
      // console.log("getRankSummary", response)
      return true;
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchTournamentReport = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getTounamentReport(queryParams)
    .then((response) => {
      // const { totalCount, entities } = response.data;
      const totalCount = response.count;
      const entities = response.list;
      dispatch(actions.TournamentReportFetched({ totalCount, entities }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchCompanyDropdownList = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .fetchCompanyDropdownList(queryParams)
    .then((response) => {
      console.log("response::All Company List", response);
      // const { totalCount, entities } = response.data;
      const companyDropdownList = response;
      console.log("fetchCompanyDropdownList", companyDropdownList);
      dispatch(actions.CompanyDropdownList({ companyDropdownList }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const setCompleteStatusByContestId = (item) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .setCompleteStatusByContestId(item)
    .then(() => {
      NotificationManager.success("success", "Data saved successfully!");
      return true;
    })
    .catch((error) => {
      // error.clientMessage = "Can't update item";
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ errMsg, callType: callTypes.action }));
      return false;
    });
};

export const fetchTournamentReportExport = (queryParams) => (dispatch) => {
  return requestFromServer
    .getTournamentReportExportList(queryParams)
    .then((response) => {
      console.log("calling getCrmCSV", response);
      if (response?.link) {
        NotificationManager.success("success", "File Download Success");
        window.open(response?.link, "_blank");
      } else {
        NotificationManager.success("success", "File Download Success");
        console.log("response::fetchTournamentReportExport ", response);
        const exportData = response;
        dispatch(actions.contestsExport({ exportData }));
      }
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const getTournamentRoundCount = id => dispatch => {
  // dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer.getTournamentRoundCount(id)
    .then(response => {
      dispatch(actions.tournamentRoundCount(response.data));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const getTournamentContestCount = id => dispatch => {
  // dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer.getTournamentContestCount(id)
    .then(response => {
      dispatch(actions.tournamentContestCount(response.data));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const getTournamentFullContestCount = id => dispatch => {
  // dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer.getTournamentFullContestCount(id)
    .then(response => {
      dispatch(actions.tournamentFullContestCount(response.data));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const getTournamentCancellationReason = id => dispatch => {
  // dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer.getTournamentCancellationReason(id)
    .then(response => {
      dispatch(actions.tournamentCancellationReason(response.data));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const fetchStaffUsers = (id) => dispatch => {
  return requestFromServer
    .getAllStaffUsers(id)
    .then(response => {
      const totalCount = response.totalRecord;
      const entities = response.data;
      dispatch(actions.staffUsersFetched({ totalCount, entities }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const getEditTournamentById = (id, isExtra) => (dispatch) => {
  if (!id) {
    return dispatch(
      actions.singleItemFetched({ tournamentForEdit: undefined })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getEditTournamentById(id, isExtra)
    .then((response) => {
      const item = response.data;
      console.log("tournamentId", response?.data?._id);

      localStorage.setItem("tournamentId", response?.data?._id); // Store id in localStorage
      dispatch(actions.singleItemFetched({ tournamentForEdit: item }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};